import { render, staticRenderFns } from "./PanelUpload.vue?vue&type=template&id=4890fd19&"
import script from "./PanelUpload.vue?vue&type=script&lang=js&"
export * from "./PanelUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports